/**
 * Compact density scale — the clinic app's third UI commitment
 * (clinic-app/CLAUDE.md §4.3: نمایش حداکثر داده‌ها در یک صفحه).
 *
 * The clinic app runs tighter than the doctor app and much tighter than the patient
 * app, on purpose: a پذیرش desk works a list of forty rows all day on a wide fixed
 * monitor, and every row that falls below the fold is a scroll the operator pays for
 * dozens of times a shift.
 *
 * The rule this file exists to enforce is "density comes from a scale, not from
 * hand-picked pixels". Before this, every table wrote its own `padding: '11px 14px'`
 * and no two agreed, so tightening a screen meant hunting magic numbers and the
 * result drifted apart again on the next change.
 *
 * Sourcing: `@parsina/framework` has no density scale yet, so this lives at layer 2
 * (app-shared) per the DESIGN.md hierarchy. Promote it to the framework — do not
 * copy it — the moment the doctor or patient app needs the same scale.
 */

/** Table/list row padding, block × inline. */
export const ROW_PAD = {
  /** Operational lists — the day panel, the cash desk queue. The default here. */
  compact: '8px 12px',
  /** Lists whose rows carry two lines of text or an avatar. */
  regular: '11px 14px',
};

/** Vertical rhythm between stacked blocks on an operational screen. */
export const STACK = {
  tight: 8,
  regular: 12,
};

/** Section padding for a panel body. */
export const PANEL_PAD = {
  compact: '10px 16px',
  regular: '14px 24px',
  /**
   * The pre-membership card body — «شروع», the registration wizard, the
   * invitation landing.
   *
   * The only place in this app that is deliberately LESS dense than the rest,
   * and the reason is that it is not an operational screen: it is seen once,
   * by someone who has never used the product, and it holds a form rather than
   * a list of forty rows. Density there buys nothing (there is no second
   * screenful to fit) and costs the one impression the product gets. It is
   * still a step on the scale rather than a hand-picked pixel pair, which is
   * the rule this file exists to keep.
   */
  roomy: '20px 28px',
};
